import { GUEST_SESSION_STORAGE_KEY } from './sessionConstants.ts'

export const setGuestSessionFlag = (): void => {
  localStorage.setItem(GUEST_SESSION_STORAGE_KEY, 'true')
}

export const clearGuestSessionFlag = (): void => {
  localStorage.removeItem(GUEST_SESSION_STORAGE_KEY)
}

export const isGuestSession = (): boolean =>
  localStorage.getItem(GUEST_SESSION_STORAGE_KEY) === 'true'
